<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M8.982,13.017c-0.62,0-1.125-0.505-1.125-1.125c0-0.62,0.505-1.125,1.125-1.125s1.125,0.505,1.125,1.125
		C10.107,12.513,9.602,13.017,8.982,13.017z"/>
	<path d="M14.982,13.017c-0.62,0-1.125-0.505-1.125-1.125c0-0.62,0.505-1.125,1.125-1.125s1.125,0.505,1.125,1.125
		C16.107,12.513,15.602,13.017,14.982,13.017z"/>
	<path d="M11.97,19.498c-1.151,0-2.265-0.338-3.223-0.979c-0.637-0.426-1.176-0.965-1.603-1.602
		c-0.111-0.167-0.151-0.367-0.112-0.563s0.152-0.366,0.319-0.477c0.124-0.083,0.268-0.126,0.416-0.126
		c0.251,0,0.484,0.125,0.624,0.333c0.316,0.473,0.716,0.873,1.189,1.189c0.711,0.475,1.537,0.726,2.39,0.726c0,0,0,0,0,0
		c1.449,0,2.792-0.716,3.593-1.915c0.139-0.209,0.373-0.333,0.624-0.333c0.148,0,0.292,0.043,0.416,0.126
		c0.344,0.23,0.437,0.697,0.208,1.041C15.731,18.533,13.921,19.498,11.97,19.498z"/>
	<path d="M2.856,24.003c-0.036,0-0.076-0.001-0.115-0.003c-0.562-0.031-1.078-0.278-1.454-0.697
		c-0.376-0.419-0.566-0.959-0.536-1.521c0.001-0.022,0.004-0.045,0.007-0.066l2-13.915c0.184-1.049,1.073-1.802,2.117-1.802
		c0.031,0,0.062,0.001,0.093,0.002L19.042,6c0.013-0.001,0.04-0.001,0.068-0.001c1.027,0,1.936,0.765,2.113,1.779l2.003,13.938
		c0.003,0.016,0.005,0.039,0.006,0.06c0.005,0.087,0.005,0.168,0,0.249c-0.034,0.561-0.284,1.075-0.706,1.448
		c-0.385,0.341-0.88,0.529-1.395,0.529l0,0c-0.043,0-0.085-0.001-0.128-0.004L2.95,24C2.923,24.002,2.891,24.003,2.856,24.003z
		 M2.248,21.89c-0.002,0.152,0.053,0.298,0.155,0.411c0.108,0.121,0.257,0.192,0.419,0.201l0.035,0.001l0.035-0.001L21.048,22.5
		l0.064,0.002c0.165,0,0.306-0.051,0.42-0.151c0.121-0.107,0.194-0.256,0.203-0.417c0.001-0.014,0.001-0.028,0.001-0.043
		L19.742,8.014c-0.051-0.288-0.326-0.515-0.637-0.515C19.102,7.499,4.936,7.5,4.936,7.5L4.891,7.499
		c-0.318,0-0.598,0.231-0.652,0.538L2.248,21.89z"/>
	<path d="M15.661,4.557c-0.359,0-0.668-0.256-0.736-0.609c-0.271-1.414-1.512-2.444-2.952-2.448
		c-1.425,0.006-2.662,1.029-2.938,2.433C8.967,4.284,8.658,4.538,8.301,4.538c0,0,0,0,0,0c-0.048,0-0.097-0.005-0.147-0.015
		C7.959,4.486,7.789,4.373,7.677,4.206S7.525,3.84,7.564,3.644C7.976,1.542,9.831,0.01,11.972,0c2.16,0.007,4.021,1.549,4.426,3.666
		c0.077,0.406-0.19,0.8-0.596,0.878C15.756,4.553,15.708,4.557,15.661,4.557z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'shopping-bag-smile',
    },
    name: {
      type: String,
      required: false,
      default: 'ShoppingBagSmile',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>